import { ad2bs as e } from "../calendar-carburettor/converter/index.js";
import { useDatePickerStore as t } from "../core/models/use-date-picker-store.js";
import { cn as n } from "../../../cn.js";
import { selectCtx as r, selectEvents as i } from "../core/models/selectors/index.js";
import a, { forwardRef as o, useCallback as s, useEffect as c, useRef as l, useState as u } from "react";
import { jsx as d, jsxs as f } from "react/jsx-runtime";
// src/design/forms/datepicker/ui/input.tsx
var p = {
	year: {
		maxDigits: 4,
		placeholder: "YYYY"
	},
	month: {
		maxDigits: 2,
		placeholder: "MM"
	},
	day: {
		maxDigits: 2,
		placeholder: "DD"
	}
};
function m() {
	return {
		year: {
			value: "",
			placeholder: "YYYY",
			maxDigits: 4
		},
		month: {
			value: "",
			placeholder: "MM",
			maxDigits: 2
		},
		day: {
			value: "",
			placeholder: "DD",
			maxDigits: 2
		}
	};
}
function h(e) {
	return e.startsWith("YYYY") ? [
		"year",
		"month",
		"day"
	] : [
		"day",
		"month",
		"year"
	];
}
function g(e) {
	return e.includes("/") ? "/" : "-";
}
function _(e, t) {
	if (!e) return null;
	let n = g(t), r = n === "/" ? "\\/" : n, i = RegExp(`^(\\d{1,4})${r}(\\d{1,2})${r}(\\d{1,4})$`), a = e.match(i);
	if (!a) return null;
	let o = h(t), s = {};
	return o.forEach((e, t) => {
		s[e] = a[t + 1];
	}), {
		year: {
			value: s.year || "",
			...p.year
		},
		month: {
			value: s.month || "",
			...p.month
		},
		day: {
			value: s.day || "",
			...p.day
		}
	};
}
function v(e, t) {
	let { year: n, month: r, day: i } = e;
	if (n.value.length < n.maxDigits || !r.value || !i.value) return "";
	let a = g(t), o = n.value.padStart(4, "0"), s = r.value.padStart(2, "0"), c = i.value.padStart(2, "0");
	return t.startsWith("YYYY") ? `${o}${a}${s}${a}${c}` : `${c}${a}${s}${a}${o}`;
}
function y(e) {
	switch (e) {
		case "year": return {
			min: 1,
			max: 9999
		};
		case "month": return {
			min: 1,
			max: 12
		};
		case "day": return {
			min: 1,
			max: 31
		};
	}
}
function b(e, t) {
	return e === "year" ? t.padStart(4, "0") : t.padStart(2, "0");
}
var x = o(({ format: e = "YYYY-MM-DD", variant: t, placeholder: r, value: i = "", onChange: o, onEnter: x, onFocus: S, onBlur: C, disabled: w, className: T }, E) => {
	let [D, O] = u(m), [k, A] = u(!1), j = l({
		year: !1,
		month: !1,
		day: !1
	}), M = l(!1), N = l(""), P = {
		year: l(null),
		month: l(null),
		day: l(null)
	}, F = h(e), I = g(e), L = t === "filter", R = l(null);
	a.useImperativeHandle(E, () => {
		let e = R.current || document.createElement("input"), t = e.focus.bind(e);
		return e.focus = () => {
			let e = F[0];
			P[e]?.current?.focus(), t();
		}, e;
	}), c(() => {
		if (i === N.current) return;
		if (N.current = i, !i) {
			O(m());
			return;
		}
		let t = _(i, e);
		t && O(t);
	}, [i, e]);
	let z = s((t) => {
		O(t);
		let n = v(t, e);
		N.current = n, o?.(n);
	}, [o, e]), B = s((e, t) => {
		z({
			...D,
			[e]: {
				...D[e],
				value: t
			}
		});
	}, [D, z]), V = s((e) => {
		P[e]?.current?.focus();
	}, [P]), H = s((e) => {
		let t = F.indexOf(e);
		t < F.length - 1 && V(F[t + 1]);
	}, [F, V]), U = s((e) => {
		let t = F.indexOf(e);
		t > 0 && V(F[t - 1]);
	}, [F, V]), W = s((e, t) => {
		let { min: n, max: r } = y(e), i = (D[e].value ? parseInt(D[e].value) : t === 1 ? n - 1 : r + 1) + t;
		i > r && (i = n), i < n && (i = r), B(e, b(e, String(i))), j.current[e] = !0;
	}, [D, B]), G = s((e, t) => {
		let { maxDigits: n } = p[t];
		if (e.length >= n) return !0;
		if (e.length === 1 && t !== "year") {
			let n = parseInt(e);
			if (t === "month") return n >= 2;
			if (t === "day") return n >= 4;
		}
		return !1;
	}, []), K = s((e, t) => {
		let n = D[t].value, r = j.current[t], { maxDigits: i } = p[t], a = r ? e : n + e;
		a.length > i && (a = e);
		let o = parseInt(a), { max: s } = y(t);
		if (t !== "year" && a.length === 2 && o > s ? a = e : t !== "year" && a.length === 2 && o === 0 && (a = e === "0" ? "" : e), B(t, a), j.current[t] = !1, G(a, t)) {
			let e = F.indexOf(t), n = e < F.length - 1 ? F[e + 1] : null;
			n && (j.current[n] = !0), M.current = !0, setTimeout(() => {
				n && V(n), M.current = !1;
			}, 0);
		}
	}, [
		D,
		B,
		G,
		F,
		V
	]), q = s((e, t) => {
		A(!0), M.current || (j.current[e] = !0), S?.(t);
	}, [S]), J = s((e, t) => {
		if (!w) switch (e.key) {
			case "ArrowUp":
				e.preventDefault(), W(t, 1);
				break;
			case "ArrowDown":
				e.preventDefault(), W(t, -1);
				break;
			case "ArrowRight":
				e.preventDefault(), H(t);
				break;
			case "ArrowLeft":
				e.preventDefault(), U(t);
				break;
			case "Backspace":
				e.preventDefault();
				{
					let e = D[t].value;
					e ? j.current[t] ? (B(t, ""), j.current[t] = !1) : B(t, e.slice(0, -1)) : U(t);
				}
				break;
			case "Tab": return;
			case "Enter":
				e.preventDefault(), x?.();
				return;
			default: e.key >= "0" && e.key <= "9" ? (e.preventDefault(), K(e.key, t)) : e.preventDefault();
		}
	}, [
		w,
		D,
		W,
		H,
		U,
		B,
		K,
		x
	]), Y = (e) => {
		let t = D[e], { min: r, max: i } = y(e), a = t.value ? e === "year" ? t.value : t.value.padStart(2, "0") : t.placeholder;
		return /* @__PURE__ */ d("span", {
			ref: P[e],
			role: "spinbutton",
			"aria-label": e.charAt(0).toUpperCase() + e.slice(1),
			"aria-valuenow": t.value ? parseInt(t.value) : void 0,
			"aria-valuemin": r,
			"aria-valuemax": i,
			tabIndex: w ? -1 : 0,
			className: n("text-center outline-hidden select-none transition-colors rounded-sm", "focus:bg-primary/10 focus:text-primary", "hover:bg-muted lowercase", e === "year" ? "min-w-[3.5ch]" : "min-w-[2ch]", L ? "text-xs" : "text-sm", "text-muted-foreground"),
			onKeyDown: (t) => J(t, e),
			onFocus: (t) => q(e, t),
			children: a
		}, e);
	};
	return /* @__PURE__ */ f("div", {
		className: n("inline-flex items-center bg-transparent", "gap-0", L ? "w-19 max-w-19 min-w-19" : "w-22 min-w-22 max-w-22", "text-muted-foreground", "p-0 pl-1", w && "cursor-not-allowed opacity-50", T),
		onBlur: (e) => {
			e.currentTarget.contains(e.relatedTarget) || (A(!1), C?.(e));
		},
		children: [/* @__PURE__ */ d("input", {
			ref: R,
			type: "hidden",
			"aria-hidden": "true",
			tabIndex: -1
		}), F.map((e, t) => /* @__PURE__ */ f(a.Fragment, { children: [Y(e), t < F.length - 1 && /* @__PURE__ */ d("span", {
			className: n("select-none pointer-events-none", L ? "text-xs text-muted-foreground" : "text-sm text-muted-foreground"),
			children: I
		})] }, e))]
	});
});
x.displayName = "InputWithMask";
var S = (t) => (n) => !t || !n.ctx.isNepali ? t : e(t), C = o(({ value: e, onChange: n, variant: o = "filter", ...s }, c) => {
	let l = t((t) => S(e || "")(t)), [f, p] = u(""), { isDisabled: m } = t(r), { closeCalendar: h } = t(i);
	a.useEffect(() => {
		p(l);
	}, [l]);
	let g = (e) => {
		p(e), n?.(e);
	};
	return /* @__PURE__ */ d(x, {
		ref: c,
		value: f,
		...s,
		onChange: (e) => {
			g(e);
		},
		onEnter: h,
		variant: o,
		disabled: m
	});
});
export { C as Input, x as InputWithMask };

//# sourceMappingURL=input.js.map